/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { OfferNoteEntryCreatedByResponse } from '../../models/offer-note-entry-created-by-response';

export interface GetOfferNoteEntriesAuthors$Params {
  id: number;
}

export function getOfferNoteEntriesAuthors(http: HttpClient, rootUrl: string, params: GetOfferNoteEntriesAuthors$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<OfferNoteEntryCreatedByResponse>>> {
  const rb = new RequestBuilder(rootUrl, getOfferNoteEntriesAuthors.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<OfferNoteEntryCreatedByResponse>>;
    })
  );
}

getOfferNoteEntriesAuthors.PATH = '/offers/{id}/note-entries/authors';
